import { FormBuilder, FormControl } from '@angular/forms';
import { ControlProperty, FileAttachment } from '../../../../../../../common/models';

export class AllocationViewUliCommentsModel {
  checkNeeded = false;
  comment: string = null;
  attachments: FileAttachment[] = [];

  constructor(params?: AllocationViewUliCommentsModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliCommentsForm {
  constructor(
    model: AllocationViewUliCommentsModel,
    fb: FormBuilder,
    public checkNeeded: ControlProperty<boolean> = model.checkNeeded,
    public comment: ControlProperty<string> = model.comment,
    public attachments: FormControl<FileAttachment[]> = null,
  ) {
    this.attachments = fb.control(model.attachments);
  }
}
